import React from "react";
import { accionesItems } from "../../json/acciones";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

import "./detalleAcciones.css";

const DetalleAcciones = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { enlace } = useParams();
  const accion = accionesItems.find((accion) => accion.enlace === enlace);

  return (
    <div className="container acciones-container">
      <div className="row">
        <div className="col_12">
          <div className="acciones_title">
            <h1>{accion.nombre}</h1>
            <div className="row">
              {accion.accionDiaNaranja ? (
                accion.accionDiaNaranja.map((accion1, index) => {
                  return (
                    <div key={index} className="col-md-12 col-12">
                      <div className="accion_container_detalle">
                        <div className="detalle_accion_nombre">               
                        </div>
                      </div>

                      <div className="row">
                      <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active" data-bs-interval="2000">
      <img src="../img/acciones/DiaNaranja/comite.jpg" class="d-block w-100 img-carrusel" alt="..."/>
    </div>
{accion1.carrusel.map((img, index)=>
    <div Key={index} class="carousel-item" data-bs-interval="2000">
      <img src={img.imagen} class="d-block w-100 img-carrusel" alt="..."/>
      <div class="carousel-caption d-none d-md-block titulo_img_carrusel">
        <h5 className=" titulo-img"> {img.titulo} </h5>
        <p className=" texto-img">Some representative placeholder content for the first slide.</p>
      </div>
    </div>
)}
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
<hr></hr>
<div>{accion1.texto}</div> 
                      </div>
                     
                    </div>
                  );
                })
              ) 
               
                : (
                  
                     accion.accionProtocolo?(
                      accion.accionProtocolo.map((accion2, index) => {
                        return (
                          <div key={index} className="col-md-12 col-12">
                            <div className="accion_container_detalle">
                              <div className="detalle_accion_nombre">
                                              
                              </div>
                            </div>
                            <div className="row">
                            <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                            <div class="carousel-item active" data-bs-interval="2000">
                              <img src="../img/acciones/NiñosSader/marzo_1.jpg" class="d-block w-100 img-carrusel" alt="..."/>
                              </div>
                              {accion2.carrusel.map((img, index)=>
                              <div Key={index} class="carousel-item" data-bs-interval="2000">
                                <img src={img.imagen} class="d-block w-100 img-carrusel" alt="..."/>
                                <div class="carousel-caption d-none d-md-block titulo_img_carrusel">
                                  <h5 className=" titulo-img"> {img.titulo} </h5>
                                  <p className=" texto-img">Protocolo Cero.</p>
                                  </div>
                                  </div>
                                  )}

                              </div>
                              <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Anterior</span>
                              </button>
                              <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                                 <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                 <span class="visually-hidden">Siguiente</span>
                               </button>

                             </div>
                             <hr></hr>
                             <div>{accion2.texto}</div>
                            </div>

                            </div>)

                      }
                    )):(
                      <div>
                        No info
                      </div>
                    )
                          
              ) 
              
                  
              
            }
            </div>
          </div>
        </div>
      </div>
      <div className="row"></div>
    </div>
  );
};

export default DetalleAcciones;
